var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "上传日志",
        visible: _vm.dialogVisible,
        width: "860px",
        "close-on-click-modal": true,
        "append-to-body": "",
        "custom-class": "migration-log-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "log-dialog-content" }, [
        _c("div", { staticClass: "stat-cards" }, [
          _c("div", { staticClass: "stat-card stat-card--total" }, [
            _c("div", { staticClass: "stat-icon" }, [
              _c("i", { staticClass: "el-icon-document" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat-info" }, [
              _c("span", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.total)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "stat-label" }, [_vm._v("总记录数")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card stat-card--success" }, [
            _c("div", { staticClass: "stat-icon" }, [
              _c("i", { staticClass: "el-icon-success" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat-info" }, [
              _c("span", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.successCount)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "stat-label" }, [_vm._v("成功")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card stat-card--fail" }, [
            _c("div", { staticClass: "stat-icon" }, [
              _c("i", { staticClass: "el-icon-error" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat-info" }, [
              _c("span", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.failCount)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "stat-label" }, [_vm._v("失败")]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-toolbar" }, [
          _c(
            "div",
            { staticClass: "filter-left" },
            [
              _c("el-date-picker", {
                staticStyle: { width: "220px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  "default-time": ["00:00:00", "23:59:59"],
                  clearable: "",
                  size: "small",
                },
                on: { change: _vm.handleSearch },
                model: {
                  value: _vm.searchForm.time,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "time", $$v)
                  },
                  expression: "searchForm.time",
                },
              }),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "180px" },
                  attrs: {
                    placeholder: "小程序",
                    clearable: "",
                    filterable: "",
                    size: "small",
                  },
                  on: { change: _vm.handleSearch },
                  model: {
                    value: _vm.searchForm.appId,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "appId", $$v)
                    },
                    expression: "searchForm.appId",
                  },
                },
                _vm._l(_vm.miniappList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.appName, value: item.id },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: { click: _vm.handleSearch },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.handleReset },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-right" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "text",
                    size: "small",
                    icon: "el-icon-refresh",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.loadData(_vm.inheritedCustomerId)
                    },
                  },
                },
                [_vm._v("\n          刷新\n        ")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-wrapper" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  border: "",
                  stripe: "",
                  size: "small",
                  "header-cell-style": {
                    background: "#f5f7fa",
                    color: "#606266",
                    fontWeight: "600",
                  },
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: "序号",
                    width: "60",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "adminName",
                    label: "操作人",
                    "min-width": "100",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "operator-cell" }, [
                            _c("div", { staticClass: "operator-avatar" }, [
                              _vm._v(
                                _vm._s(_vm.getAvatarText(scope.row.adminName))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(scope.row.adminName || "-")),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "appName",
                    label: "小程序",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.appName || "-")),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "operateTime",
                    label: "操作时间",
                    "min-width": "160",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "fileName",
                    label: "上传文件",
                    "min-width": "160",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.fileName
                            ? _c("div", { staticClass: "file-cell" }, [
                                _c("i", {
                                  staticClass: "el-icon-document excel-icon",
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "file-name",
                                    attrs: { title: scope.row.fileName },
                                  },
                                  [_vm._v(_vm._s(scope.row.fileName))]
                                ),
                              ])
                            : _c("span", { staticClass: "no-data" }, [
                                _vm._v("-"),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "successNum",
                    label: "成功数量",
                    width: "100",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", { staticClass: "num-success" }, [
                            _vm._v(_vm._s(scope.row.successNum || 0)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "failNum",
                    label: "失败数量",
                    width: "100",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.failNum > 0
                            ? _c("span", { staticClass: "num-fail" }, [
                                _vm._v(_vm._s(scope.row.failNum)),
                              ])
                            : _c("span", { staticClass: "num-zero" }, [
                                _vm._v(_vm._s(scope.row.failNum || 0)),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "status",
                    label: "状态",
                    width: "100",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status === 1
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "status-tag",
                                  attrs: {
                                    type: "warning",
                                    size: "small",
                                    effect: "plain",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-loading" }),
                                  _vm._v(" 处理中\n            "),
                                ]
                              )
                            : scope.row.status === 2
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "status-tag",
                                  attrs: {
                                    type: "success",
                                    size: "small",
                                    effect: "plain",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-circle-check",
                                  }),
                                  _vm._v(" 成功\n            "),
                                ]
                              )
                            : scope.row.status === 3
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "status-tag",
                                  attrs: {
                                    type: "danger",
                                    size: "small",
                                    effect: "plain",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-circle-close",
                                  }),
                                  _vm._v(" 失败\n            "),
                                ]
                              )
                            : _c("span", { staticClass: "no-data" }, [
                                _vm._v("-"),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    width: "120",
                    align: "center",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "action-btns" },
                            [
                              scope.row.fileUrl
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "action-btn",
                                      attrs: {
                                        type: "text",
                                        size: "small",
                                        icon: "el-icon-download",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downloadFile(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                下载\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getFailReasonText(scope.row.failReason)
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.getFailReasonText(
                                          scope.row.failReason
                                        ),
                                        placement: "top",
                                        "open-delay": 300,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass:
                                            "action-btn action-btn--warn",
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                            icon: "el-icon-warning-outline",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  详情\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !scope.row.fileUrl &&
                              !_vm.getFailReasonText(scope.row.failReason)
                                ? _c("span", { staticClass: "no-data" }, [
                                    _vm._v("-"),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.loading && _vm.tableData.length === 0
          ? _c("div", { staticClass: "empty-state" }, [
              _c("div", { staticClass: "empty-icon" }, [
                _c("i", { staticClass: "el-icon-folder-opened" }),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "empty-title" }, [_vm._v("暂无迁移记录")]),
              _vm._v(" "),
              _c("p", { staticClass: "empty-desc" }, [
                _vm._v(
                  "当前条件下没有找到迁移日志，请检查筛选条件或进行新的迁移操作"
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.total > 0
          ? _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("el-pagination", {
                  attrs: {
                    "page-sizes": [10, 20, 50],
                    "page-size": _vm.pageFrom.limit,
                    "current-page": _vm.pageFrom.page,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handlePageChange,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }